// extracted by mini-css-extract-plugin
var _1 = "ChatroomMessageEditFormFiles-modulechatroomMessageEditFormFiles__cqf39 ChatroomInputFormFields-modulefileList__gFblS";
var _2 = "ChatroomMessageEditFormFiles-moduleitem__VmI4L ChatroomInputFormFields-modulefileListItem__r0maF";
export { _1 as "chatroomMessageEditFormFiles", _2 as "item" }
